import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Baseline defaults — mirrors backend DEFAULT_CONTENT for graceful offline / first paint.
export const DEFAULT_CONTENT = {
  hero: {
    kicker: "360° Business Growth Partner",
    line1: "Transforming",
    line2: "businesses through",
    line3_gradient: "strategy, creativity",
    line4: "& innovation.",
    sub: "We help ambitious brands grow with integrated Events, Branding, Digital Marketing, Media Production and Technology — under one roof.",
    primary_cta: "Get Free Consultation",
    secondary_cta: "View Portfolio",
  },
  stats: [
    { value: 12, suffix: "+", label: "Years of craft" },
    { value: 640, suffix: "+", label: "Projects delivered" },
    { value: 280, suffix: "+", label: "Brands partnered" },
    { value: 18, suffix: "", label: "Cities activated" },
  ],
  trusted: ["NEXORA", "Vantage", "Lumière", "Kairos", "Northwind", "Halcyon", "Meridian", "Cobalt", "Everly", "Zephyr", "Aurora", "Ironclad"],
  chapters: [],
  about: {
    overline: "About VYFT",
    heading_pre: "A manifesto for ",
    heading_gradient: "measurable",
    heading_post: " growth.",
    body: "VYFT began with a simple belief: brands don't need ten agencies, they need one partner accountable for growth. Today we operate as a 360° studio across events, media, branding, technology and performance.",
    mission: "Engineer integrated growth for ambitious brands.",
    vision: "Become the most trusted growth partner in the region.",
    values: "Craft, transparency, speed and measurable outcomes.",
  },
  services: [], why: [], process: [], testimonials: [], team: [], insights: [], industries: [],
  contact: {
    email: "info@vyft.media",
    phone_display: "+91 92179 93809",
    phone_raw: "+919217993809",
    whatsapp_number: "919217993809",
    whatsapp_text: "Hi VYFT, I'd like a consultation",
    address: "Welldone Techpark, 304, Sector 48, Gurugram 122018",
    map_embed_url: "https://www.google.com/maps?q=Welldone%20Techpark%2C%20Sector%2048%2C%20Gurugram%20122018&output=embed",
  },
};

const SiteContentContext = createContext({ content: DEFAULT_CONTENT, loading: false, refresh: () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent({ ...DEFAULT_CONTENT, ...data });
    } catch {
      // keep defaults
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
